"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _indexBy = _interopRequireDefault(require("transmute/indexBy"));

var _get = _interopRequireDefault(require("transmute/get"));

var _setIn = _interopRequireDefault(require("transmute/setIn"));

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  active: false,
  activeMultiCurrency: undefined,
  companyCurrency: undefined,
  currencyCodes: (0, _immutable.Map)(),
  currencies: (0, _immutable.Map)()
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.MultiCurrencyActionTypes.ACITVE_MULTI_CURRENCY_SELECTED, function (state, action) {
  return state.set('activeMultiCurrency', state.get('currencies').get(action.payload.currencyCode));
}), (0, _defineProperty2.default)(_handleActions, _actions.MultiCurrencyActionTypes.ACITVE_MULTI_CURRENCY_UNSELECTED, function (state) {
  return state.set('activeMultiCurrency', undefined);
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchMultiCurrencyActiveActionTypes.SUCCESS, function (state, action) {
  var response = action.payload.data;
  return state.merge({
    active: response.hasMulticurrencyActive,
    companyCurrency: response.homeCurrency.currencyCode,
    currencies: (0, _indexBy.default)((0, _get.default)('fromCurrencyCode'), (0, _immutable.List)(response.currencyExchangeRates))
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchCompanyCurrencyActionTypes.SUCCESS, function (state, action) {
  return state.set('companyCurrency', action.payload.data.currencyCode);
}), (0, _defineProperty2.default)(_handleActions, _actions.SetCompanyCurrencyActionTypes.SUCCESS, function (state, action) {
  var _action$payload$props = action.payload.props,
      companyCurrencyCode = _action$payload$props.companyCurrencyCode,
      updatedCurrencyExchangeRates = _action$payload$props.updatedCurrencyExchangeRates;

  if (updatedCurrencyExchangeRates && updatedCurrencyExchangeRates.length) {
    updatedCurrencyExchangeRates.forEach(function (update) {
      state = (0, _setIn.default)(['currencies', update.fromCurrencyCode, 'conversionMultiplier'], update.conversionMultiplier, state);
    });
  }

  return state.merge({
    active: true,
    companyCurrency: companyCurrencyCode
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchMultiCurrencyCodesActionTypes.SUCCESS, function (state, action) {
  return state.set('currencyCodes', action.payload.data.reduce(function (acc, currencyCode) {
    return acc.set(currencyCode, {
      value: currencyCode
    });
  }, (0, _immutable.Map)()));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchMultiCurrenciesActionTypes.SUCCESS, function (state, action) {
  return state.set('currencies', (0, _indexBy.default)((0, _get.default)('fromCurrencyCode'), (0, _immutable.List)(action.payload.data)));
}), (0, _defineProperty2.default)(_handleActions, _actions.SetMultiCurrencyActionTypes.SUCCESS, function (state, action) {
  return state.setIn(['currencies', action.payload.data.fromCurrencyCode], action.payload.data);
}), (0, _defineProperty2.default)(_handleActions, _actions.ArchiveMultiCurrencyActionTypes.SUCCESS, function (state, action) {
  var currency = state.getIn(['currencies', action.payload.props.fromCurrencyCode]);
  return state.setIn(['currencies', action.payload.props.fromCurrencyCode], (0, _extends2.default)({}, currency, {
    visible: false
  }));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;